import { toastSuccess, toastError } from '../utils/toastMessage';
import API from '../utils/API';

export const updateUserDataSuccess = (data) => {
  return {
    type: 'UPDATE_USER_DATA_SUCCESS',
    data,
  };
};

export const updateUserData = (user) => {
  const {
    id,
    params: { age, weight, height, activity_id, gender_id },
    goals,
  } = user;
  return () => {
    API.put(`/users/params/${id}`, {
      age,
      weight,
      height,
      activity_id,
      gender_id,
      goal_weight: goals,
      by_user: 0, // TODO: what it is?
    })
      .then(() => {
        toastSuccess('Данные успешно сохранены!');
      })
      .catch(() => {
        toastError('В процессе обновления данных пользователя возникла ошибка');
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/updateUserData.js